import React from 'react';
import { CardDescription } from '@udemy/react-product-card-components';
import { safelySetInnerHTML } from '@udemy/shared-utils';

/**
 * ### CourseCardDescription
 *
 * Renders the course headline for the `CourseProductCard` `description` prop
 * from a `Course` object
 */
export const CourseCardDescription = ({
  course
}) => /*#__PURE__*/React.createElement(CardDescription, null, /*#__PURE__*/React.createElement("span", safelySetInnerHTML({
  descriptionOfCaller: 'course-card:course-headline',
  html: course.headline
})));
//# sourceMappingURL=course-card-description.react-component.js.map